// extracted by mini-css-extract-plugin
export default {"star":"Star-module__star___tf7gF","star--selected":"Star-module__star--selected___x67am"};